export function getSearchString() {
    var search = window.location.search;
    var hash = window.location.hash.substring(1);
    return search && search !== ''
        ? search
        : hash.includes('?')
            ? hash.split('?')[1]
            : hash;
}
